import React from "react";
import Label from "components/Label";

type Props = {
  title: string;
};

const TitleAuth: React.FC<Props> = ({ title }): JSX.Element => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-center items-center">
        <Label label={title} className="font-light text-2xl text-bt-purple" />
      </div>
    </div>
  );
};

export default TitleAuth;
